(() => {
  let dialog, player, title, status, opener;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'tv65-dialog';
    dialog.setAttribute('aria-labelledby', 'tv65-video-title');
    dialog.innerHTML = '<div class="tv65-dialog-bar"><h2 id="tv65-video-title"></h2><button type="button" aria-label="Close video" data-tv65-close>×</button></div><video controls playsinline preload="none"></video><p class="tv65-status" role="status"></p>';
    document.body.append(dialog);
    player = dialog.querySelector('video');
    title = dialog.querySelector('h2');
    status = dialog.querySelector('[role="status"]');
    const close = () => dialog.close();
    dialog.querySelector('button').addEventListener('click', close);
    dialog.addEventListener('click', e => { if (e.target === dialog) close(); });
    dialog.addEventListener('close', () => {
      player.pause(); player.removeAttribute('src'); player.load();
      document.documentElement.classList.remove('tv65-video-open');
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
    player.addEventListener('error', () => { status.textContent = 'The video could not load. Please try again later.'; });
  }
  document.addEventListener('click', e => {
    const card = e.target.closest('[data-tv65-src]');
    if (card) {
      ensureDialog(); opener = card; title.textContent = card.dataset.tv65Title;
      status.textContent = ''; player.poster = card.querySelector('img').src;
      player.src = card.dataset.tv65Src; player.muted = false;
      dialog.showModal(); document.documentElement.classList.add('tv65-video-open');
      player.play().catch(() => { status.textContent = 'Tap the play button to start the video.'; });
      return;
    }
    const arrow = e.target.closest('[data-tv65-step]');
    if (arrow) {
      const track = arrow.closest('[data-tv65-rail]').querySelector('.tv65-track');
      track.scrollBy({left: Number(arrow.dataset.tv65Step) * track.clientWidth * .85, behavior: reduced() ? 'instant' : 'smooth'});
    }
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden && player) player.pause(); });
  document.addEventListener('shopify:section:unload', () => { if (dialog?.open) dialog.close(); });
})();
